// frontend/src/services/assistant-status.service.ts
import { get } from '@/lib/api-client';

export interface AssistantEnabledStatus {
  /** Org-level tenant master switch for the assessor assistant. */
  enabled: boolean;
}

/**
 * Probe whether the assessor assistant is switched on for the muni's org.
 * Authenticated; answers even when off (so the sidebar can hide the nav).
 */
export async function getAssistantEnabled(
  muniId: string,
  signal?: AbortSignal,
): Promise<AssistantEnabledStatus> {
  return get<AssistantEnabledStatus>(
    `/api/m/${muniId}/assistant/enabled`,
    signal ? { signal } : undefined,
  );
}
